<script setup>
</script>

<template>
<div class="flex items-center justify-center min-h-screen overflow-hidden" >
    <!-- <spinner-svg1/> -->
     <div class="relative">
         <div class="loader"></div> 
         <!-- <div class="max-w-40">
            <img src="/images/loader.gif" alt="">
         </div> -->

     </div>
</div>

</template>
<style >

.loader {
  height: 15px;
  aspect-ratio: 6;
  display: flex;
}
.loader:before,
.loader:after {
  content: "";
  flex: 1;
  padding-left: calc(100%/6);
  background: radial-gradient(closest-side at calc(100%/3) 50%,#2A85FF 90%,#0000) 0/75% 100% content-box;
  animation: l21 2s infinite;
}
.loader:after {
  --_s:-1;
}
@keyframes l21 {
    0%       {transform:scale(var(--_s,1)) translate(0)    rotate(0)}
    25%      {transform:scale(var(--_s,1)) translate(-25%) rotate(0)}
    50%      {transform:scale(var(--_s,1)) translate(-25%) rotate(1turn)}
    75%,100% {transform:scale(var(--_s,1)) translate(0)    rotate(1turn)}
} 

</style>
